import { ReactNode } from 'react';

import { tv } from 'tailwind-variants';

import cn from '@/helpers/utils/classNames';

interface TextSmallProps {
  children: ReactNode;
  className?: string;
  variant?:
    | 'primary'
    | 'secondary'
    | 'light'
    | 'dark'
    | 'dark-red'
    | 'light-gray'
    | 'medium-gray'
    | 'dark-gray'
    | 'silver'
    | 'orange'
    | 'danger';
}

export const textSmallStyles = tv({
  variants: {
    color: {
      primary: 'text-primary',
      secondary: 'text-secondary-light',
      light: 'text-white',
      dark: 'text-black',
      orange: 'text-orange-400',
      'dark-red': 'text-dark-red',
      'light-gray': 'text-grayscale-95',
      'medium-gray': 'text-grayscale-80',
      'dark-gray': 'text-grayscale-96',
      silver: 'text-silver',
      danger: 'text-red-500',
    },
  },
});

const TextSmall = ({ children, className, variant = 'dark' }: TextSmallProps) => {
  return (
    <p
      className={cn(
        textSmallStyles({
          color: variant,
        }),
        'font-thin leading-[1.125rem] sm:text-[0.7rem] md:text-[0.75rem] lg:text-[0.8125rem] xs:text-[0.65rem] xxs:text-[0.65rem]',
        className
      )}
    >
      {children}
    </p>
  );
};

export default TextSmall;
